import { render, staticRenderFns } from "./phoneRotation.vue?vue&type=template&id=31d4eed4&scoped=true&"
import script from "./phoneRotation.vue?vue&type=script&lang=js&"
export * from "./phoneRotation.vue?vue&type=script&lang=js&"
import style0 from "./phoneRotation.vue?vue&type=style&index=0&id=31d4eed4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4eed4",
  null
  
)

export default component.exports